export const formatZipCode = (zipcode?: string | null) => {
  if (!zipcode) return "";

  const value = zipcode.replace(/\D/g, "").slice(0, 8);

  if (value.length <= 5) return value;

  return `${value.substring(0, 5)}-${value.substring(5, 8)}`;
};
